/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import Button from '../../../Button';
import Input from '../../../Input';
import { classnames } from '../../../../utils/text';
import { transformComma } from '../../../../utils/validator/comma';

const TaxSingoItemInputNumber = ({ data, openDataMemo, onChange }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    setText(data.value);
  }, [data]);

  const cancel = () => {
    setText(data.value);
  }

  const _onChange = useCallback((a) => {
    const status = 'pending' || 'completed1'
    const updatedData = { ...data, value: text, status };
    onChange(updatedData)
  }, [data, text])

  const _setText = (value) => {
    setText(transformComma(value))
  }
  return (
    <div className={classnames("tax-singo-item-box", {
      "drop-box-on": data.value !== text
    })}>
      <div className='tax-singo-item-value'>
        {text || '-'}
      </div>
      <div className='tax-singo-item-drop-box' style={{ minWidth: '200px' }}>
        <div className='tax-sing-item-drop-box-header'>
          <Input
            value={text}
            placeholder={`${data.name} 를 입력해주세요.`}
            onChange={(e) =>
              _setText(e.target.value)}
          />
          {data.value !== text && '변경된 내용이 저장 되지 않습니다.'}
        </div>
        <div className="tax-singo-item-bottom">
          {data.value !== text && <>
            <Button
              label={'취소'}
              size="tiny"
              color="danger"
              onClick={() => cancel()}
            />
            <Button
              label={'저장'}
              size="tiny"
              onClick={(data) => _onChange()}
            />
          </>}
          <Button
            label={'메모'}
            size="tiny"
            color="info"
            onClick={() => openDataMemo(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default TaxSingoItemInputNumber;